import { palette, global } from './config';

const defaultTheme = {
    colors: {
        app_bg: palette.white,
        black: palette.black,
        blackButtonBackground: palette.primary,
        border: palette.grey,
        borderSecondary: palette.silver,
        buttonGrey: palette.iron,
        disable: palette.grey,
        error: palette.red,
        formBlue: palette.pictonBlue,
        formNewFieldBlue: palette.dustyBlue,
        grey: palette.grey,
        headerBg: palette.alto,
        hover: palette.blue,
        inputBorder: palette.iron,
        linkHover: palette.green31,
        paginationBackground: palette.primary,
        paginationBorder: palette.emperor40,
        placeholder: palette.emperor,
        primary: palette.primary,
        primaryButtonDisabled: palette.silver,
        profileBorder: palette.alto,
        profileImageBorder: palette.emperor,
        secondary: palette.red,
        tableHeaderBorder: palette.dustyGray,
        text: palette.emperor,
        textAreaBg: palette.wildSand,
        textLine: palette.alto,
        transcriptionTextBorder: palette.emperor,
        waveBackground: palette.lightGrey,
        white: palette.white,
    },
    ...global,
};

export default defaultTheme;
